import type { CrmRelationship, CrmStage } from '@discovr/features';

const NEUTRAL = 'bg-stone-200 text-stone-600';
const POSITIVE = 'bg-emerald-100 text-emerald-700';
const ACTIVE = 'bg-(--brand-100) text-(--brand-600)';

/** Figma's CRM pill per stage. Exhaustive so a new stage fails to compile here instead of rendering blank. */
export const CRM_STAGE_STYLES: Record<CrmStage, { label: string; cls: string }> = {
  suppressed: { label: 'Suppressed', cls: NEUTRAL },
  brand_declined: { label: 'Brand declined', cls: NEUTRAL },
  closed: { label: 'Closed', cls: NEUTRAL },
  escalated: { label: 'Escalated', cls: 'bg-rose-100 text-rose-700' },
  with_brand: { label: 'With brand', cls: POSITIVE },
  question_open: { label: 'Question open', cls: 'bg-amber-100 text-(--foreground-warning-default)' },
  rate_locked: { label: 'Rate locked', cls: POSITIVE },
  negotiating: { label: 'Negotiating', cls: ACTIVE },
  replied: { label: 'Replied', cls: 'bg-(--brand-50) text-(--brand-600)' },
  sent: { label: 'Sent', cls: NEUTRAL },
  scheduled: { label: 'Scheduled', cls: 'bg-(--brand-50) text-(--brand-600)' },
  not_contacted: { label: 'Not contacted', cls: NEUTRAL },
};

export function crmStageLabel(stage: CrmStage): string {
  return CRM_STAGE_STYLES[stage].label;
}

/** Figma's Relationship pill on the All creators list. */
export const CRM_RELATIONSHIP_STYLES: Record<CrmRelationship, { label: string; cls: string }> = {
  never_contacted: { label: 'Never contacted', cls: NEUTRAL },
  in_conversation: { label: 'In conversation', cls: ACTIVE },
  with_brand: { label: 'With brand', cls: ACTIVE },
  rate_agreed: { label: 'Rate agreed', cls: ACTIVE },
  closed: { label: 'Closed', cls: NEUTRAL },
  suppressed: { label: 'Suppressed', cls: NEUTRAL },
};
